import { useEffect, useState } from "react";
import { getNotes } from "./api";
import { FormWithTitle } from "components/FormWithTitle/FormWithTitle";
import { Loading } from "components/Loading/loading";

interface NotesProps{
  reload?:boolean,
  refrenceId:any
  setResetForm?:any
}

export const Notes = ({ refrenceId,reload,setResetForm }:NotesProps) => {
  const [notes, setNotes] = useState<any>(null);
  const [loading,setLoading]=useState(false)

  const getNotesAsync = async () => {
    setLoading(false)
    try {
      const res = await getNotes(refrenceId);
      setNotes(res.Data);
    } catch (error) {}
    setLoading(true)
   setResetForm&& setResetForm(false)
  };

  useEffect(() => {
    getNotesAsync();
  }, [reload]);

  return (
    <>
      {loading?
      notes  ? (
        <FormWithTitle
          closeOption={true}
          cardClass="mt-3 mb-3 px-2 pb-2"
          title="insertnote"
        >
          <div

            dangerouslySetInnerHTML={{
              __html: !!notes.length
                ? notes
                    .split("<p>")
                    .slice(1)
                    .map((item) => {
                      return `<div style="word-wrap: break-word;direction:rtl">&bull;${item.replaceAll(
                        "\n",
                        "</br>"
                      )}</div>`;
                    })
                    .join("")
                : "",
            }}
          ></div>
        </FormWithTitle>
      ) : (
        <></>
      ):<Loading/>}
    </>
  );
};
